<template>
  <div
    class="select-data-panel"
    v-if="showLeft"
  >
    <div class="select-panel-title">
      请选择日期
    </div>
    <div class="select-panel-content">
      <div class="label-content">请选择年份：</div>
      <div class="btnList-content">
        <div
          class="item-content"
          v-for="(item, index) in yearList"
          :key="'y' + index"
          @click="selectedOneYear(item, index)"
        >
          <div class="item-name">{{ item.name }}</div>
          <span :class="[activeYearIndex === index ? 'triangle-bottom' : '']"></span>
        </div>
      </div>
      <div class="label-content">请选择月份：</div>
      <div class="btnList-content btnList-content-month">
        <div
          class="item-content"
          :class="{ outDate: index > currentMonIndex && isMonthControll }"
          v-for="(item, index) in monthList"
          :key="'m' + index"
          @click="selectedOneMonth(item, index)"
        >
          <div class="item-name">{{ item.name }}</div>
          <span :class="[activeMonthIndex === index ? 'triangle-bottom' : '']"></span>
        </div>
      </div>
      <div
        v-if="showDayList"
        class="label-content"
      >请选择日期：</div>
      <div
        v-if="showDayList"
        class="btnList-content btnList-content-day"
      >
        <div
          :class="[
            'item-content',
            item.name === '占位' ? 'item-null' : '',
            index > currentDayIndex && isDateChontroll ? 'outDate' : ''
          ]"
          v-for="(item, index) in dayList"
          :key="'m' + index"
          @click="selectedOneDay(item, index)"
        >
          <div
            v-if="item.name !== '占位'"
            :class="['item-name']"
          >
            {{ item.name }}
          </div>
          <span
            v-if="item.name !== '占位'"
            :class="[activeDayIndex === index ? 'triangle-bottom' : '']"
          ></span>
        </div>
      </div>
    </div>
    <div class="btn-content">
      <div
        class="button-cancel"
        @click="hideMenu"
      >取消</div>
      <div
        class="button-confirm"
        @click="comfirmBtn"
      >确定</div>
    </div>
  </div>
</template>

<script>
export default {
  name: '',
  data () {
    return {
      activeYearIndex: 0,
      activeMonthIndex: 0,
      activeDayIndex: 0,
      selectedYear: '2020',
      selectedMonth: '1月',
      selectedDay: '',
      selectedDate: '20190717',
      currentMonIndex: 0,
      currentDayIndex: 0,
      isDateChontroll: false,
      isMonthControll: false
    }
  },
  computed: {
    dateStr () {
      return this.$store.state.dateStr
    },
    szlDateIn () {
      return this.$store.state.inSzlDate
    },
    szlDateOut () {
      return this.$store.state.outSzlDate
    },
    szlType () {
      return this.$route.query.pageType
    },
    showLeft () {
      return this.$store.state.showLeft
    },
    yearList () {
      const nowDate = new Date()
      const year = nowDate.getFullYear()
      const yList = []
      for (let i = year; i > year - 9; i--) {
        const y = {}
        y.name = i
        yList.push(y)
      }
      return yList
    },
    monthList () {
      const list = []
      for (let i = 1; i <= 12; i++) {
        const obj = {}
        obj.name = i + '月'
        list.push(obj)
      }
      return list
    },
    dayNum () {
      const monthNum = this.selectedMonth.substring(
        0,
        this.selectedMonth.length - 1
      )
      let dayNum = 30
      if (
        parseInt(monthNum) === 1 ||
        parseInt(monthNum) === 3 ||
        parseInt(monthNum) === 5 ||
        parseInt(monthNum) === 7 ||
        parseInt(monthNum) === 8 ||
        parseInt(monthNum) === 10 ||
        parseInt(monthNum) === 12
      ) {
        dayNum = 31
      }
      if (parseInt(monthNum) === 2) {
        const cond1 = this.selectedYear % 4 === 0 // 条件1：年份必须要能被4整除
        const cond2 = this.selectedYear % 100 !== 0 // 条件2：年份不能是整百数
        const cond3 = this.selectedYear % 400 === 0 // 条件3：年份是400的倍数
        // 当条件1和条件2同时成立时，就肯定是闰年，所以条件1和条件2之间为“与”的关系。
        // 如果条件1和条件2不能同时成立，但如果条件3能成立，则仍然是闰年。所以条件3与前2项为“或”的关系。
        // 所以得出判断闰年的表达式：
        if ((cond1 && cond2) || cond3) {
          dayNum = 29
        } else {
          dayNum = 28
        }
      }

      return dayNum
    },
    dayList () {
      // console.log('初始的月', this.selectedMonth, '年', this.selectedYear)
      const monthNum = this.selectedMonth.substring(
        0,
        this.selectedMonth.length - 1
      )
      let dayNum = 30
      if (
        parseInt(monthNum) === 1 ||
        parseInt(monthNum) === 3 ||
        parseInt(monthNum) === 5 ||
        parseInt(monthNum) === 7 ||
        parseInt(monthNum) === 8 ||
        parseInt(monthNum) === 10 ||
        parseInt(monthNum) === 12
      ) {
        dayNum = 31
      }
      if (parseInt(monthNum) === 2) {
        const cond1 = this.selectedYear % 4 === 0 // 条件1：年份必须要能被4整除
        const cond2 = this.selectedYear % 100 !== 0 // 条件2：年份不能是整百数
        const cond3 = this.selectedYear % 400 === 0 // 条件3：年份是400的倍数
        // 当条件1和条件2同时成立时，就肯定是闰年，所以条件1和条件2之间为“与”的关系。
        // 如果条件1和条件2不能同时成立，但如果条件3能成立，则仍然是闰年。所以条件3与前2项为“或”的关系。
        // 所以得出判断闰年的表达式：
        if ((cond1 && cond2) || cond3) {
          dayNum = 29
        } else {
          dayNum = 28
        }
      }
      const list = []
      for (let i = 1; i <= dayNum; i++) {
        const obj = {}
        obj.name = i + '日'
        list.push(obj)
      }
      if (dayNum === 28) {
        list.push({ name: '占位' })
        list.push({ name: '占位' })
      }
      if (dayNum === 29) {
        list.push({ name: '占位' })
      }
      if (dayNum === 31) {
        list.push({ name: '占位' })
        list.push({ name: '占位' })
      }
      return list
    },
    showDayList () {
      return this.$store.state.showDayList
    }
  },
  methods: {
    selectedOneYear (item, index) {
      this.activeYearIndex = index
      this.selectedYear = item.name
      this.getIsDateOut()
    },
    selectedOneMonth (item, index) {
      this.activeMonthIndex = index
      this.selectedMonth = item.name
      this.getIsDateOut()
    },
    selectedOneDay (item, index) {
      if (item.name !== '占位') {
        this.activeDayIndex = index
        this.selectedDay = item.name
        this.getIsDateOut()
      }
    },
    getIsDateOut () {
      if (this.activeDayIndex > this.dayNum - 1) { // 判断日是否超出当月最大值
        this.activeDayIndex = this.dayNum - 1
        this.selectedDay = this.dayNum + '日'
      }
      // 每点击及初始的时间按钮都判断是否超出当前时间
      if (this.szlType === 'szlIn') {
        // 市占率的要根据截止时间控制，超出就不给选
        this.currentMonIndex = parseFloat(this.szlDateIn.substring(4, 6)) - 1
      } else if (this.szlType === 'szlOut') {
        this.currentMonIndex = parseFloat(this.szlDateOut.substring(4, 6)) - 1
      } else {
        this.currentMonIndex = new Date().getMonth()
        this.currentDayIndex = new Date().getDate() - 1
      }

      if (this.activeYearIndex === 0) {
        // 处理样式控制
        this.isMonthControll = true
        if (this.activeMonthIndex === this.currentMonIndex) {
          this.isDateChontroll = true
        } else {
          this.isDateChontroll = false
        }
      } else {
        this.isDateChontroll = false
        this.isMonthControll = false
      }
      if (this.activeYearIndex === 0) {
        // 判断时间是否超出当前，超出当前则取当前时间
        if (
          this.activeMonthIndex > this.currentMonIndex ||
          this.activeMonthIndex === this.currentMonIndex
        ) {
          this.isDateChontroll = true
          this.activeMonthIndex = this.currentMonIndex
          this.selectedMonth = parseInt(this.currentMonIndex + 1) + '月'
          // this.getIsDateOut()
          if (this.activeDayIndex > this.currentDayIndex) {
            this.activeDayIndex = this.currentDayIndex
            this.selectedDay = parseInt(this.currentDayIndex + 1) + '日'
          }
        }
      }
    },
    hideMenu () {
      this.$store.commit('updateShowLeft', false)
      this.$store.commit('updateShowMask', false)
    },
    comfirmBtn () {
      // 当在筛选页点了确定
      const y = this.yearList[this.activeYearIndex].name
      const m = this.activeMonthIndex + 1 + ''
      const d = this.activeDayIndex + 1 + ''
      let dateStr = y + m.padStart(2, '0')
      if (this.showDayList) {
        dateStr = y + m.padStart(2, '0') + d.padStart(2, '0')
      }
      // console.log('dateStr', dateStr)
      this.$store.commit('updateDateStr', dateStr)
      this.$store.commit('updateShowLeft', false)
      this.$store.commit('updateShowMask', false)
      this.$eventBus.$emit('userSelected', dateStr)
      if (this.szlType === 'szlIn' || this.szlType === 'szlOut') {
        // 如果在市占率筛选过时间，就不带到首页
        this.$store.commit('updateInitDateStr', true)
      } else {
        this.$store.commit('updateInitDateStr', false)
      }
    }
  },
  mounted () { },
  watch: {
    showLeft: {
      handler (newData, oldData) {
        if (newData) {
          const y = parseInt(this.dateStr.substring(0, 4))
          const m = parseInt(this.dateStr.substring(4, 6))
          if (this.showDayList) {
            const d = parseInt(this.dateStr.substring(6, 8))
            this.activeDayIndex = d - 1
          }
          const nowDate = new Date()
          const year = nowDate.getFullYear()
          this.activeYearIndex = year - y
          this.activeMonthIndex = m - 1
          this.selectedMonth = m + '月'
          this.selectedYear = y
          this.getIsDateOut()
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
%btn-panel {
  width: 50%;
  height: 100%;
  line-height: 1.3rem;
  text-align: center;
  vertical-align: middle;
}
.select-data-panel {
  position: absolute;
  z-index: 999;
  height: 100%;
  width: 61.8%;
  right: 0;
  top: 0;
  border-left: px2rem(1) solid #888;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  background-color: #0c1446;
  opacity: 1;
  animation: changePanel 300ms;

  .select-panel-title {
    position: relative;
    width: 100%;
    height: px2rem(88);
    min-height: px2rem(88);
    line-height: px2rem(88);
    text-align: center;
    vertical-align: middle;
    color: #fff;
    font-size: 0.5rem;
    background-color: #07235a;
    opacity: 1;
  }
  .select-panel-content {
    position: relative;
    flex: 1;
    margin-bottom: px2rem(50);
    width: 100%;
    overflow-y: auto;
    animation: btnBox 300ms;
    .label-content {
      width: 90%;
      margin-left: px2rem(16);
      height: px2rem(60);
      line-height: px2rem(60);
      vertical-align: middle;
      font-size: px2rem(24);
      color: #fff;
    }
    .selected-content {
      width: 100%;
      height: px2rem(400);
      background-color: #ff5f01;
    }
    .btnList-content {
      width: 100%;
      height: px2rem(240);
      display: flex;
      justify-content: flex-start;
      align-items: flex-start;
      flex-flow: row wrap;
      .outDate.item-content {
        border: 1px solid rgb(95, 110, 150);
        .item-name {
          color: rgb(95, 110, 150);
        }
      }
      .item-content {
        border: px2rem(1) solid #34c9f8;
        position: relative;
        margin: px2rem(10) auto;
        height: px2rem(50);
        line-height: px2rem(50);
        width: px2rem(120);
        text-align: center;
        .item-name {
          font-size: px2rem(24);
          color: #34c9f8;
        }
        .triangle-bottom {
          width: 0;
          height: 0;
          display: inline-block;
          position: absolute;
          bottom: 0;
          right: 0;
          border-bottom: px2rem(20) solid #34c9f8;
          border-left: px2rem(20) solid transparent;
        }
      }
      .item-null {
        border: none;
      }
    }
    .btnList-content-month {
      width: 100%;
      height: px2rem(300);
    }
    .btnList-content-day {
      width: 100%;
      height: px2rem(800);
    }
  }
  .btn-content {
    width: 100%;
    height: px2rem(104);
    min-height: px2rem(104);
    background: #09103d;
    color: #d5d8df;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 0.5rem;
    display: flex;
  }
  .button-confirm {
    @extend %btn-panel;
    background-color: #202d77;
  }
  .button-cancel {
    @extend %btn-panel;
  }
  @keyframes changePanel {
    0% {
      width: 0%;
    }
    100% {
      width: 61.8%;
    }
  }
  @keyframes btnBox {
    10% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }
}
</style>
